import React, {Component} from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import ListingContainer from "../../../containers/listing_container";
import {AGENT_API_URL} from "../../../constants/api_routes";
import ViewAgentUserDetails from "./view_user_details";
import CreateAgentUser from "./create_user";
import UpdateAgentUser from "./update_user";
import {Button, Header, Icon, Modal, Popup, Grid} from "semantic-ui-react";
import Loader from "../../universal/loader";
import ChangeUserEmail from "../../auth/change_email";
import ChangePassword from "../../auth/change_password";

class Agent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: 'listing',
            showConfirm: false,
            userDeleteSelectedId: null
        }
    }

    componentWillMount() {
        this.setState({action: 'listing'});
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if(this.state.action === 'change_email' && nextState.action === "listing"){
            this.props.getList(AGENT_API_URL);
        }
    }


    handleView(row) {
        this.setState({action: 'view'});
        this.props.viewDetails(this.props.data.filter((e) => {
            return e.id === row;
        }));
    }

    handleEdit(row) {
        this.setState({action: 'update'});
        this.props.editDetails(this.props.data.filter((e) => {
            return e.id === row;
        }));
    }

    handleCreate() {
        this.setState({action: 'create'});
    }

    handleDelete(row) {
        this.props.deleteDetail(AGENT_API_URL, row);
        this.setState({showConfirm: false});
    }

    setListing = () => {
        this.setState({action: 'listing'});
    };

    render() {
        const columns = [{
            Header: 'Name',
            accessor: 'name',
            filterable: true
        }, {
            Header: 'Email',
            accessor: 'email',
            filterable: true,
            Cell: ({original,value}) => (

                <div className="icon-button" onClick={() => {this.setState({ currentUserId:original['user_id'],currentUserEmail: value ,action:'change_email'})}}>
                    {value}
                </div>
            )
        }, {
            Header: 'Phone Number',
            accessor: 'mobile_number',
            filterable: true
        },{
            Header: 'Company Name',
            accessor: 'company_name',
            filterable: true
        }, {
            Header: 'Address',
            accessor: 'address',
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? String(row[id]).toUpperCase().indexOf(filter.value.toUpperCase()) >= 0 : true
            },
            filterable: true,
            className:'caddress-width',
            headerClassName:'caddress-width'
        }, {
            Header: 'Action',
            id: 'edit',
            accessor: 'id',
            className:'table-actions',
            headerClassName:'table-actions',
            Cell: ({value}) => (
                <div>
                    <Button basic compact icon primary size='mini' onClick={(e) => this.handleEdit(value)}><Icon
                        name='edit'/>Edit</Button>
                    <Popup
                        trigger={<Button basic compact icon negative size='mini'><Icon name='user delete'/></Button>}
                        content={<Button negative content='Confirm Remove user?'
                                         onClick={(e) => this.handleDelete(value)}/>}
                        on='click'
                        position='right center'
                        hideOnScroll
                    />
                </div>
            )
        }];

        return (<div className="listing-container pad-top">

                <div style={{display:'flex'}} className="pad-bottom">
                    <div>
                        <Header content="Agent Users" size='large'/>
                    </div>
                    <div style={{marginLeft:'1%'}}>
                        <Button primary icon labelPosition='right' onClick={(e) => {
                            this.handleCreate()
                        }}>Add New Agent <Icon name='plus'/>
                        </Button>
                    </div>
                </div>
                <div>
                    {this.props.isFetching && <Loader/>}
                    {!this.props.isFetching && this.props.data.length > 0 && <ReactTable
                        data={this.props.data}
                        columns={columns}
                        defaultFilterMethod={(filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                        }}
                        noDataText="No Agents Found"
                        defaultPageSize={10}
                        minRows={0}
                    />}

                    <Modal size="large" open={this.state.action !== "listing"} onClose={(e) => {
                        this.setState({action: "listing"})
                    }}>
                        <Modal.Content>
                            <div className="modal-close-button">
                                <Button basic icon negative onClick={(e) => {
                                    this.setState({action: "listing"})
                                }}><Icon name="close"/></Button>
                            </div>
                            <Modal.Description>
                                {this.state.action === 'view' &&
                                <ViewAgentUserDetails selectedObject={this.props.selectedObject}/>}
                                {this.state.action === 'update' &&
                                <UpdateAgentUser selectedObject={this.props.selectedObject}
                                                 onSuccess={this.setListing}/>}
                                {this.state.action === 'create' && <CreateAgentUser onSuccess={this.setListing}/>}
                                {this.state.action === 'change_email' && <div style={{height:'350px'}}><Grid textAlign='center' style={{height: '100%'}} verticalAlign='middle'>
                    <Grid.Column width={8}>
                    <ChangeUserEmail userId={this.state.currentUserId} userEmail = {this.state.currentUserEmail} onSuccess={this.setListing} userType={this.props.userRole  === 'admin' ? 'admin' : 'others'}/>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <ChangePassword userId={this.state.currentUserId} onSuccess={this.setListing} />
                    </Grid.Column>
                </Grid></div>}
                            </Modal.Description>
                        </Modal.Content>
                    </Modal>
                    {!this.props.isFetching && !(this.props.data.length > 0) &&
                    <div className='center'>No Available users. Add user?</div>}
                </div>
            </div>
        );
    }
}

export default ListingContainer(Agent);


// WEBPACK FOOTER //
// ./src/views/user/agent/index.js